module.exports = __webpack_public_path__ + "static/Toolkit-1c316026227f23af2dd998b596d85d40.jpg";